var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 26.7V15h1.55v11.7Zm.7 6.8q-.5 0-.9-.4t-.4-.95q0-.5.4-.9t.9-.4q.5 0 .9.4t.4.9q0 .55-.4.95-.4.4-.9.4Zm6.35-24.2h9.15v1.55h-6.55l2.1 2.1q2.6 2.45 3.725 5.25t1.125 5.6q0 4.75-2.675 8.625T30.2 38.15V36.5q3.75-1.65 5.95-5.1 2.2-3.45 2.2-7.6 0-2.65-.95-5.025-.95-2.375-3-4.375l-2.5-2.45v6.5h-1.55Zm-12.7 29.4H8.5v-1.55H15l-2.05-2.1q-2.5-2.55-3.675-5.3Q8.1 27 8.1 24.25q0-4.8 2.65-8.675Q13.4 11.7 17.85 9.9v1.6q-3.8 1.65-6 5.125t-2.2 7.625q0 2.6.95 4.975.95 2.375 3.05 4.375l2.5 2.45v-6.5h1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnError);
export default __webpack_public_path__ + "static/media/conn-error.c402aa6aaa8c55592133473bbf05986b.svg";
export { ForwardRef as ReactComponent };